<template lang="html">
    <div id="d-page-template-1">

      <section class="short-info-section-s1" v-if="!loading">
        <div class="box-top">
          <div class="col-sm-6 col-title">
            <h2>Plan de carrera</h2>
          </div>

        </div>
        <!-- <div class="box-vacations-info">
          <div class="col-sm-4 col-info">
            <h5 class="title">Total de cursos matriz comerical:</h5>
            <h4 class="number">{{row.total_commercial_courses}}</h4>
          </div>
        </div> -->
      </section>

      <section class="requests-section" v-if="!loading">

        <div class="box-results">
          <b-card no-body>
            <b-tabs class="tabs-lg" card>

              <b-card-text>
                <div class="no-gutters no-v-alignment post-template-s6" v-for="(v, vInx) in rows" :key="'vInx-'+vInx">
                  <div class="col-lg-6 pr-lg-1">
                    <div class="box-content">
                      <div class="box-title">
                        <h6 class="t">¿Dónde estoy?</h6>
                      </div>

                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title">Puesto</h6>
                            <p class="f-w-700">{{ $root.user.position }}</p>
                          </div>
                          <div class="col-6 col-info">
                            <h6 class="title">Agencia</h6>
                            <p class="f-w-700">{{ $root.user.agencies }}</p>
                          </div>

                          <div class="col-12 col-info">
                            <h6 class="title">Jefe inmediato</h6>
                            <p class="f-w-700">{{ $root.user.immediate_boss }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 pl-lg-1">
                    <div class="box-content">
                      <div class="box-title">
                        <h6 class="t">A dónde voy?</h6>
                      </div>

                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title">Nivel tabulador proyectado:</h6>
                            <p class="f-w-700">{{v.projected_tablelevel}}</p>
                          </div>
                          <div class="col-6 col-info">
                            <h6 class="title">Puesto proyectado:</h6>
                            <p class="f-w-700">{{v.projected_positions}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="my-3 no-border box-content">
                    <div class="box-info-cols">
                      <div class="row _row no-border">
                        <div class="col-12 px-0 col-progress">
                          <div class="box-progress">
                            <h6 class="title">Avance para lograr ser considerado</h6>

                            <b-progress :max="100">
                              <b-progress-bar :value="v.total_advance" :label="`${((v.total_advance / 100) * 100)}%`"></b-progress-bar>
                            </b-progress>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="box-content">
                    <div class="box-title">
                      <h6 class="t">Preparación para lograrlo</h6>
                    </div>

                    <div class="box-info-cols">
                      <div class="row _row">
                        <div class="col-3 col-info">
                          <h6 class="title">Total de cursos matriz comerical</h6>
                          <p class="f-w-700">{{v.total_commercial_courses}}</p>
                        </div>
                        <div class="col-3 col-info">
                          <h6 class="title">Total de cursos matriz operativa/ténica</h6>
                          <p class="f-w-700">{{v.total_operational_courses || 'n/d'}}</p>
                        </div>
                        <div class="col-3 col-info">
                          <h6 class="title">Total de cursos e-learning matriz operativa/ténica</h6>
                          <p class="f-w-700">{{v.total_learning_courses || 'n/d'}}</p>
                        </div>
                        <div class="col-3 col-info">
                          <h6 class="title">Total de cursos internos</h6>
                          <p class="f-w-700">{{v.total_internal_courses || 'n/d'}}</p>
                        </div>
                      </div>

                      <div class="row _row">
                        <div class="col-3 col-info">
                          <h6 class="title">Numero de cursos total</h6>
                          <p class="f-w-700">{{v.total_courses}}</p>
                        </div>
                        <div class="col-3 col-info">
                          <h6 class="title">Inversion matriz comerical</h6>
                          <p class="f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(v.inversion_commercial_courses) }}</p>
                        </div>
                        <div class="col-3 col-info">
                          <h6 class="title">Inversion cursos matriz operativa/ténica</h6>
                          <p class="f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(v.inversion_operational_courses) }}</p>
                        </div>
                        <div class="col-3 col-info">
                          <h6 class="title">Inversion cursos e-learning matriz operativa/ténica</h6>
                          <p class="f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(v.inversion_learning_courses) }}</p>
                        </div>
                      </div>

                      <div class="row _row">
                        <div class="col-3 col-info">
                          <h6 class="title">Inversion cursos internos</h6>
                          <p class="f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(v.inversion_internal_courses) }}</p>
                        </div>
                        <div class="col-3 col-info">
                          <h6 class="title">Inversion económica total</h6>
                          <p class="f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(v.inversion_total) }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 box-content">
                    <div class="box-title">
                      <h6 class="t">Plan de carrera y avance</h6>
                    </div>
                  </div>
                  <div class="col-xl-6 pr-xl-1">
                    <div class="box-content">
                      <div class="box-title bg-color-2">
                        <h6 class="t">Plan de carrera</h6>
                      </div>

                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-12 col-table-s1">
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <th class="cell-data">Datos</th>
                                  <th>KPI´S de requisito</th>
                                  <th class="cell-percent">% Peso</th>
                                </tr>
                              </thead>

                              <tbody>
                                <!-- <tr>
                                  <th>Puesto actual</th>
                                  <td><p class="f-w-700">Consultor de Ventas</p></td>
                                  <td><p class="f-w-700">N/A</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Puesto crecimiento</th>
                                  <td><p class="f-w-700">Coordinación- Gerencia de Ventas/F&I</p></td>
                                  <td><p class="f-w-700">N/A</p></td>
                                </tr> -->
                                <tr>
                                  <th class="title">Formación acádemica indispensable</th>
                                  <td><p class="f-w-700">{{v.academic_training}}</p></td>
                                  <td><p class="f-w-700">20%</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Habilidades generales (conducir , sistemas, etc)</th>
                                  <td><p class="f-w-700">{{v.general_skills}}</p></td>
                                  <td><p class="f-w-700">20%</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Examen de conocimientos</th>
                                  <td><p class="f-w-700">{{v.knowledge_exam}}</p></td>
                                  <td><p class="f-w-700">12.5%</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Entrevistas gte/coord área</th>
                                  <td><p class="f-w-700">{{v.interviews}}</p></td>
                                  <td><p class="f-w-700">12.5%</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Evaluación cualitativa</th>
                                  <td><p class="f-w-700">{{v.qualitative_evaluation}}</p></td>
                                  <td><p class="f-w-700">15%</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Evaluación cuantitativa</th>
                                  <td><p class="f-w-700">{{v.quantitative_evaluation}}</p></td>
                                  <td><p class="f-w-700">15%</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Antigüedad</th>
                                  <td><p class="f-w-700">{{v.antiquity}}</p></td>
                                  <td><p class="f-w-700">5%</p></td>
                                </tr>
                                <tr class="row-total">
                                  <th class="title" colspan="2">Total</th>
                                  <td><p class="f-w-700">100%</p></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-6 pl-xl-1">
                    <div class="box-content">
                      <div class="box-title bg-color-2">
                        <h6 class="t">Avance en plan de carrera</h6>
                      </div>

                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-12 col-table-s1">
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <th class="cell-data">Datos</th>
                                  <th>KPI´S actuales</th>
                                  <th class="cell-percent">% Avance</th>
                                </tr>
                              </thead>

                              <tbody>
                                <!-- <tr>
                                  <th>Puesto actual</th>
                                  <td><p class="f-w-700">N/A</p></td>
                                  <td><p class="f-w-700">N/A</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Puesto crecimiento</th>
                                  <td><p class="f-w-700">N/A</p></td>
                                  <td><p class="f-w-700">N/A</p></td>
                                </tr> -->
                                <tr>
                                  <th class="title">Formación acádemica indispensable</th>
                                  <td><p class="f-w-700">{{v.academic_training_advance}}</p></td>
                                  <td><p class="f-w-700">{{v.academic_training_advance_achieved}}</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Habilidades generales (conducir , sistemas, etc)</th>
                                  <td><p class="f-w-700">{{v.general_skills_advance}}</p></td>
                                  <td><p class="f-w-700">{{v.general_skills_advance_advance}}</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Examen de conocimientos</th>
                                  <td><p class="f-w-700">{{v.knowledge_exam_advance}}</p></td>
                                  <td><p class="f-w-700">{{v.knowledge_exam_advance_advance}}</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Entrevistas gte/coord área</th>
                                  <td><p class="f-w-700">{{v.interviews_advance}}</p></td>
                                  <td><p class="f-w-700">{{v.interviews_advance_advance}}</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Evaluación cualitativa</th>
                                  <td><p class="f-w-700">{{v.qualitative_evaluation_advance}}</p></td>
                                  <td><p class="f-w-700">{{v.qualitative_evaluation_advance_achieved}}</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Evaluación cuantitativa</th>
                                  <td><p class="f-w-700">{{v.quantitative_evaluation_advance}}</p></td>
                                  <td><p class="f-w-700">{{v.quantitative_evaluation_advance_achieved}}</p></td>
                                </tr>
                                <tr>
                                  <th class="title">Antigüedad</th>
                                  <td><p class="f-w-700">{{v.antiquity_advance}}</p></td>
                                  <td><p class="f-w-700">{{v.antiquity_advance_achieved}}</p></td>
                                </tr>
                                <tr class="row-total">
                                  <th class="title" colspan="2">Total</th>
                                  <td><p class="f-w-700">{{ v.total_advance}} %</p></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 box-content">
                    <div class="box-title">
                      <h6 class="t">Plan de desarrollo</h6>
                    </div>

                    <div class="box-info-cols">
                      <div class="row _row">
                        <div class="col-4 col-info">
                          <h6 class="title">Acciones para desarrollar fortalezas</h6>
                          <p class="f-w-700">{{v.actions_develop_strengths}}</p>
                        </div>
                        <div class="col-4 col-info">
                          <h6 class="title">Sugerencias para mejorar áreas de</h6>
                          <p class="f-w-700">{{v.sugestions_improve_areas}}</p>
                        </div>
                        <div class="col-4 col-info">
                          <h6 class="title">Plan de desarrollo</h6>
                          <p class="f-w-700">{{v.development_plan}}</p>
                        </div>
                      </div>

                      <div class="row _row">
                        <div class="col-4 col-info">
                          <h6 class="title">Responsable</h6>
                          <p class="f-w-700">{{v.responsible}}</p>
                        </div>
                        <div class="col-4 col-info">
                          <h6 class="title">Periodo resultados</h6>
                          <p class="f-w-700">{{v.period_results}}</p>
                        </div>
                        <div class="col-4 col-info">
                          <h6 class="title">Periodo cumplimiento</h6>
                          <p class="f-w-700">{{v.compliance_period}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-tabs>
          </b-card>
        </div>
      </section>
      <section class="requests-section" v-else>
          <div class="box-results" style="padding-top: 150px;text-align: center;">
                <div class="fa-5x"><i class="fas fa-spinner fa-pulse"></i></div><br>
          </div>
      </section>

    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        row:{},
        rows:[],

        modal:{
          msg:'',
          icon:'',
          block:false,
        },
        loading:false,
        // == ==
      }
    },

    methods: {
        getRows(){
          this.loading = true;
          axios.get(tools.url("/api/user/career")).then((response)=>{
              this.row = response.data.row;
              this.rows = response.data.rows;

              this.loading = false;
          }).catch(()=>{
            this.loading = false;
          });
        },

    },
    mounted() {
        this.getRows();
    },
  }
  </script>
